import {KColorInput} from "@feature/kcolor/kcolor-input";
import evaluateBlockDependencies from "@utils/evaluateBlockDependencies";
import ConfiguratorContext from "@components/ConfiguratorContext";
import {useContext} from "react";

const ConfiguratorSurveyKColorInput = (
  {
    value,
    onChange,
    disabled,
    metadata,
    responses,
  }
) => {

  const context = useContext(ConfiguratorContext);

  const selectableProducts = Object.entries(metadata?.products_dependencies ?? {}).reduce(
    (productsAcc, [productCode, productData]) => {
      const {disabled, dependencies, ...packages} = productData;

      // 1. Check if the product is selectable in its entirety
      const productSelectable = !disabled && (
        !dependencies?.length ||
        evaluateBlockDependencies(dependencies, {
          ...context,
          responses: responses
        })
      );

      if (!productSelectable) return productsAcc;

      // 2. Collect selectable packages
      const selectablePackages = Object.entries(packages).reduce(
        (packagesAcc, [packageQty, packageData]) => {
          const {disabled, dependencies} = packageData;
          const packageSelectable = !disabled && (
            !dependencies?.length ||
            evaluateBlockDependencies(dependencies, {
              ...context,
              responses: responses
            })
          );
          if (packageSelectable) return [...packagesAcc, Number(packageQty)];
          return packagesAcc;
        },
        []
      );
      // 3. Collect packages that are disabled
      const disabledPackages = Object.entries(packages).reduce(
        (packagesAcc, [packageQty, packageData]) => {
          const {disabled, dependencies} = packageData;
          if (disabled) {
            return [...packagesAcc, Number(packageQty)];
          } else {
            return packagesAcc;
          }
        },
        []
      );

      // If all packages are disabled, skip this product
      if (disabledPackages.length === Object.keys(packages).length) {
        return productsAcc;
      }

      // If no packages are selectable due to dependencies evaluation, then return all packages that
      // are not disabled. This ensures that at least some packages are selectable for the product, but
      // only those that are not explicitly disabled.
      if (
        selectablePackages.length === 0
      ) {
        return {...productsAcc, [productCode]: Object.keys(packages).filter(qty => !disabledPackages.includes(Number(qty))).map(Number)};
      } else {
        return {...productsAcc, [productCode]: selectablePackages};
      }
    },
    {}
  ) ?? {};

  return (
    <KColorInput
      value={value}
      onChange={onChange}
      selectableProducts={selectableProducts}
      selectableColorsExceptions={metadata?.colorsException}
      inSurvey={true}
      disabled={disabled}
    />
  );
}

export default ConfiguratorSurveyKColorInput;